import { createTheme } from '@mui/material/styles';

// Light Theme
const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#4267B2', // Soft rich blue
    },
    secondary: {
      main: '#FFC857', // Warm gold
    },
    background: {
      default: '#FAF9F6', // Warm white
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2C2C2C', // Deep grey
      secondary: '#6D6D6D', // Lighter grey for secondary text
    },
  },
  typography: {
    fontFamily: 'Inter, Arial, sans-serif',
    h5: {
      fontWeight: 600,
    },
    body1: {
      fontWeight: 400,
    },
    button: {
      textTransform: 'none', // Disable uppercase for button text
    },
  },
});

// Dark Theme
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#4267B2', // Soft rich blue
    },
    secondary: {
      main: '#66D9E8', // Gentle mint green
    },
    background: {
      default: '#1E1E1E', // Soft dark grey
      paper: '#2C2C2C',
    },
    text: {
      primary: '#F5F5F5', // Light grey
      secondary: '#B3B3B3', // Muted grey for secondary text
    },
  },
  typography: {
    fontFamily: 'Inter, Arial, sans-serif',
    h5: {
      fontWeight: 600,
    },
    body1: {
      fontWeight: 400,
    },
    button: {
      textTransform: 'none',
    },
  },
});

export { lightTheme, darkTheme };
